import { Injectable } from '@angular/core';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { Question } from '@app/models/recruiting/question.model';

@Injectable()
export class JobPostingQuestionsService {
    async save(jobPosting: JobPosting, questions: Question[]): Promise<Question[]> {
        const savedQuestions = [];

        // Want to sequentially call each promise to ensure proper order.
        for (const question of questions) {
            question.jobId = jobPosting.id;
            const savedQuestion = await question.save();
            savedQuestions.push(savedQuestion);
        }

        return savedQuestions;
    }
}
